<template>
	<tfoot>
		<slot></slot>
	</tfoot>
</template>
<script>
  export default {
  	name: 'XTfoot'
  }
</script>